export default "__VITE_ASSET__8ENKmSS$__"